import { render, staticRenderFns } from "./viewOrder.vue?vue&type=template&id=3cb06de4&scoped=true&"
import script from "./viewOrder.vue?vue&type=script&lang=js&"
export * from "./viewOrder.vue?vue&type=script&lang=js&"
import style0 from "./viewOrder.vue?vue&type=style&index=0&id=3cb06de4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb06de4",
  null
  
)

export default component.exports